import { Base } from "../../framework/base";
import { ApprovalType, RiskTreatmentState, RiskType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IRiskAssessmentListItem {
    id: string;
    riskId: string;
    riskType: RiskType;
    date: number;
    assessor: string;
    nextAssessmentDate: number;
    likelihood: number;
    impact: number;
    riskLevel: number;
    controlEffiency: number;
    residualRiskLevel: number;
    approval?: ApprovalType;
    approvalDate?: number;
    approvalAuthority: string;
    treatmentTargetDate?: number;
    treatmentState: RiskTreatmentState;
    modifyUser: IModifyUser;
    handlers: IModifyUser[];
    isRead: boolean;
    locked: boolean;
}

export class RiskAssessmentListItem implements IRiskAssessmentListItem {
    id: string;
    riskId: string;
    riskType: RiskType;
    date: number;
    assessor: string;
    nextAssessmentDate: number;
    likelihood: number;
    impact: number;
    riskLevel: number;
    controlEffiency: number;
    residualRiskLevel: number;
    approval?: ApprovalType;
    approvalDate?: number;
    approvalAuthority: string;
    treatmentTargetDate?: number;
    treatmentState: RiskTreatmentState;
    modifyUser: ModifyUser;
    handlers: ModifyUser[];
    isRead: boolean;
    locked: boolean;

    constructor();
    constructor(obj: IRiskAssessmentListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.riskId = obj && obj.riskId || "";
        this.riskType = obj && obj.riskType || RiskType.Risk;
        this.date = obj && obj.date || 0;
        this.assessor = obj && obj.assessor || "";
        this.nextAssessmentDate = obj && obj.nextAssessmentDate || null;
        this.likelihood = obj && obj.likelihood || 0;
        this.impact = obj && obj.impact || 0;
        this.riskLevel = obj && obj.riskLevel || 0;
        this.controlEffiency = obj && obj.controlEffiency || 0;
        this.residualRiskLevel = obj && obj.residualRiskLevel || 0;
        this.approval = obj && obj.approval || null;
        this.approvalDate = obj && obj.approvalDate || null;
        this.approvalAuthority = obj && obj.approvalAuthority || "";
        this.treatmentTargetDate = obj && obj.treatmentTargetDate || null;
        this.treatmentState = obj && obj.treatmentState || RiskTreatmentState.TreatmentsSpecified;
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.handlers = Base.getTypedArray(obj?.handlers, ModifyUser);
        this.isRead = obj && obj.isRead || false;
        this.locked = obj && obj.locked || false;
    }
}
